document.addEventListener('DOMContentLoaded', function() {
    const quoteForm = document.querySelectorAll('.sychem-form-quote-product__form');
    const heroButton = document.querySelector('#sychem-product-enquiry');
    const modal = document.getElementById("productFormModal");
    const onPage = document.querySelector('.sychem-form-quote-product__container.on-page');
    const close = document.getElementsByClassName("sychem-form-quote-product__modal__close")[0];
    const body = document.querySelector("body");
    const configTable = document.querySelector('.sychem-configuration-table');

    /**
     * Opens the modal by adding the "show" class to the modal element
     * and sets the body's overflow style to "hidden".
     */
    const openModal = () => {
        modal.classList.add("show");
        body.style.overflow = "hidden";
    }

    /**
     * Closes the modal by removing the "show" class from the modal element
     * and restores the body's overflow style to "auto".
     */
    const closeModal = () => {
        modal.classList.remove("show");
        body.style.overflow = "auto";
    }

    /*
        * If heroButton exists, add an event listener - click
        * When the button is clicked, find the closest sychem-std-page-hero element
        * and get all the product spec select elements
        * If the modal has product spec select elements, update the values
        * If the onPage form has product spec select elements, update the values
        * If a popup blocker is detected, open the modal
        * Otherwise, scroll the onPage form into view
    */
    if (heroButton) {
        heroButton.addEventListener('click', function(e) {
            const hero = e.target.closest('.sychem-std-page-hero');
            const specSelect = hero.querySelectorAll('.sychem-form__product-spec');
    
            if (specSelect.length > 0) {
                const modalSpecSelect = modal.querySelectorAll('.sychem-form__product-spec');
                specSelect.forEach((item, index) => {
                    modalSpecSelect[index].querySelector('select').value = item.querySelector('select').value;
                });
    
                // and on-page form
                const onpageSpecSelect = onPage.querySelectorAll('.sychem-form__product-spec');
                specSelect.forEach((item, index) => {
                    onpageSpecSelect[index].querySelector('select').value = item.querySelector('select').value;
                });
            }
            
            try {
                openModal();
            } catch (error) {
                console.error("Failed to open modal:", error);
                window.scrollTo({
                    top: onPage.offsetTop - 100,
                    behavior: "smooth"
                });
            }
        });
    }

    if (configTable) {
        const tableEquireButtons = document.querySelectorAll('.enquire-button');

        tableEquireButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.stopPropagation();
                e.preventDefault();
                
                try {
                    openModal();
                } catch (error) {
                    console.error("Failed to open modal:", error);
                    // scroll onPage into view
                    window.scrollTo({
                        top: onPage.offsetTop - 100,
                        behavior: "smooth"
                    });
                }
            });
        });

    }

    // Close the modal when the close button is clicked
    close.addEventListener('click', function() {
        closeModal();
    });
        
    // Close the modal when the user clicks outside the modal
    modal.addEventListener('click', function(event) {
        if (event.target == modal || event.target == close) {
            closeModal();
        }
    });

    /*
        * Form submission
        * Prevents the default form submission and validates the form fields
        * Displays an error message if a field is invalid
        * If the form is valid, you can send the form data using fetch or XMLHttpRequest
    */
    if (quoteForm && quoteForm.length > 0) {
        quoteForm.forEach(function(form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault(); // Prevent the default form submission
                const submitBtn = form.querySelector('.sychem-form__submit');
                submitBtn.disabled = true;
                const validationErrors = form.querySelectorAll('.validation-error');
                if (validationErrors.length > 0) {
                    validationErrors.forEach(function(el) {
                        el.classList.remove('validation-error');
                        el.querySelector('.sychem-form__group__error').innerHTML = '';
                    });
                }
    
                const formData = new FormData(form); // Create a new FormData object
                let formValidationErrors = [];
                
                /* 
                    * Validate form fields
                    * - fName: First name should not be empty and should have at least 2 characters
                    * - lName: Last name should not be empty and should have at least 2 characters
                    * - company: Company name should not be empty and should have at least 2 characters
                    * - email: Email should be in a valid format
                    * - phone: Phone number should be in a valid format
                */
                for (let [name, value] of formData.entries()) {
                    
                    if (name === 'fName') {
                        if (value === '' || value.length < 2) {              
                            formValidationErrors[name] = 'Please enter your first name';
                        }
                    }

                    if (name === 'lName') {
                        if (value === '' || value.length < 2) {
                            formValidationErrors[name] = 'Please enter your last name';
                        }
                    }

                    if (name === 'company') {
                        if (value === '' || value.length < 2) {
                            formValidationErrors[name] = 'Please enter your company name';
                        }
                    }

                    if (name === 'email') {
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailRegex.test(value)) {
                            formValidationErrors[name] = 'Please enter a valid email address';
                        }
                    }

                    if (name === 'phone') {
                        /*
                        * Phone number regex
                        * Optional leading + for international numbers.
                        * Country code with or without parentheses.
                        * Spaces or hyphens as separators.
                        * A range of digit lengths to accommodate different phone number formats.
                        * 
                        * never be perfect, but it should cover most common phone number formats.
                        */
                        const phoneRegex = /^\+?(\d{1,4}|\d{1,4}\s\d{1,4}|\(\d{1,4}\))?\s?\d{1,4}(\s|-)?\d{1,4}(\s|-)?\d{1,9}$/;
                        if (!phoneRegex.test(value)) {
                            formValidationErrors[name] = 'Please enter a valid phone number';
                        }
                    }
                }

                // if formData includes sector
                if (!formData.has('sector')) {
                    formValidationErrors['sector'] = 'Please select your sector';
                }

                if (formValidationErrors && Object.keys(formValidationErrors).length > 0) {
                    Object.keys(formValidationErrors).map((key) => { // foreach object key in formValidationErrors render the error message
                        let input = form.querySelector(`[name="${key}"]`);
                        const error = formValidationErrors[key];
                        let parent = null;

                        if (input) {
                            parent = input.parentNode;
                            parent.classList.add('validation-error');
                            const next = parent.querySelector('.sychem-form__group__error');
                            if (next) {
                                next.innerHTML = error;
                            }
                        }
                    });
                    submitBtn.disabled = false;
                    return;
                }

                // If the form is valid, you can send the form data using fetch or XMLHttpRequest
                fetch('/wp-json/sychem/v1/product-quote', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(error => {
                            throw new Error(error.message);
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.status === 'success') {
                        form.style.display = 'none'; // Hide the form
                        // Display a success message
                        const successMessage = document.querySelector('.sychem-form__group__success');
                        successMessage.style.display = 'block';
                        // reset the form and clear input fields
                        form.reset(); // Reset the form
                        submitBtn.disabled = false; // Enable the submit button
                        // remove the success message after 3 seconds and close the modal
                        setTimeout(() => {
                            closeModal();
                            successMessage.style.display = 'none';
                            form.style.display = 'block'; // Show the form
                        }, 3000);
                    } else {
                        throw new Error(data.message);
                    }
                })
                .catch(error => {
                    submitBtn.disabled = false; // Enable the submit button
                    throw new Error(error.message);
                });
            });
        });
    }
});